export default "__VITE_ASSET__BFuEwVN8__"